import { render, staticRenderFns } from "./coveradEdit.vue?vue&type=template&id=4f8896da&scoped=true&"
import script from "./coveradEdit.vue?vue&type=script&lang=js&"
export * from "./coveradEdit.vue?vue&type=script&lang=js&"
import style0 from "./coveradEdit.vue?vue&type=style&index=0&id=4f8896da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8896da",
  null
  
)

export default component.exports